import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortModal } from "app/components";
import { DrawingNationalSuperCupPairDto, TeamShortDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'drawind-national-super-cups',
    templateUrl: 'national-super-cups.page.html',
    styleUrls: ['national-super-cups.page.scss'],
})
export class DrawingNationalSuperCupsPage implements OnInit {
    
    formGroup: FormGroup;
    pairs: DrawingNationalSuperCupPairDto[];

    isLoading: boolean = false;

    constructor(private drawingService: DrawingsService,
        private modalService: NgbModal,
        private notificationService: NotificationService) { }
    
    ngOnInit(): void {
        this.loadData();
        this.buildForm();
    }

    onChangeCupWinner(countryCode: string, team: TeamShortDto) {
        const modalRef = this.modalService.open(TeamShortModal);

        modalRef.componentInstance.team = team;

        modalRef.result.then((result) => {
            if (result) {
                let pair = this.pairs.find(p => p.countryCode === countryCode);
                pair.cupWinner = result;
            }
        }, (reason) => { });
    }

    onChangeChampioshipWinner(countryCode: string, team: TeamShortDto) {
        const modalRef = this.modalService.open(TeamShortModal);

        modalRef.componentInstance.team = team;

        modalRef.result.then((result) => {
            if (result) {
                let pair = this.pairs.find(p => p.countryCode === countryCode);
                pair.championshipWinner = result;
            }
        }, (reason) => { });
    }

    onSubmit() {
        if (!this.formGroup.controls.mdFormControl.value) {
            return;
        }

        this.drawingService.saveNationalSuperCupPairs(this.pairs, this.formGroup.controls.mdFormControl.value)
            .subscribe(
                result => {
                    this.notificationService.showSuccess('Расписание сохранено..');
                }, error => {
                    this.notificationService.showError('Ошибка сохранения.');
                }
            )
    }

    private loadData() {
        this.isLoading = true;

        this.drawingService.getNationalSuperCupPairs()
            .subscribe(result => {
                this.pairs = result;
                this.isLoading = false;
            }, error=> {
                this.isLoading = false;
                this.notificationService.showError('Что-то пошло не так.');
            })
    }

    private buildForm() {
        this.formGroup = new FormGroup({
            mdFormControl: new FormControl(),
        });
    }
    
}